import React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Backdrop from "@mui/material/Backdrop";
import { Grid } from "@mui/material";
import { withStyles } from "@mui/styles";

import { useStylesLayout } from "../styles/Layout";

import NavBarSkeleton from "./NavbarSkeleton";

export const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 6,
    zIndex: theme.zIndex.drawer - 1,
  },
  colorPrimary: {
    backgroundColor: "rgba(1, 174, 78, 0.015)",
  },
  bar: {
    backgroundColor: "rgba(1, 174, 78, 1)",
  },
}))(LinearProgress);

const LoadingComponent = ({ loading, withoutNavBar = false }) => {
  const classes = useStylesLayout();

  return (
    <>
      {withoutNavBar ? null : <NavBarSkeleton />}
      <BorderLinearProgress />
      <Grid
        container
        alignItems="center"
        direction="column"
        justify="center"
        spacing={0}
        style={{ minHeight: "calc(100% - 64px)" }}
      >
        <Grid item xs={3}>
          <Backdrop invisible className={classes.backdrop} open={loading}>
            <img
              alt="logo-Loading"
              src={`${process.env.PUBLIC_URL}/ReportsLoading.png`}
              style={{ marginTop: 26, marginLeft: 8 }}
            />
          </Backdrop>
        </Grid>
      </Grid>
    </>
  );
};

LoadingComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  withoutNavBar: PropTypes.bool,
};

export default LoadingComponent;
